<template>
  <div class="profit-loss-drill-through-main">
    <div class="drill-through-body">
      <!-- <Tabulator :tableTitle="tableTitle" :tableData="drillThroughDetails" /> -->
      <!-- <TableBox :dataType="tableDataType" :hideColumns="['#']" :tableData="drillThroughDetails" :title="tableTitle" :loading="tableLoading"/> -->
      <TableBox v-if="showTableBox" :title="tableTitle" apiEndpoint="getPNLAnalysis" :apiPayload="payload" />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  data: function() {
    return {
      tableDataType : {},
      tableTitle: '',
      payload: {},
      showTableBox: false,
    }
  },
  props: {
    drillThroughDetails: { type: Array, default: function() { return [] } },
  },
  methods: {
    
  },
  async mounted() {
    var details = JSON.parse(sessionStorage.getItem(this.$route.params.drillThroughName));
    this.payload = details.data;
    this.showTableBox = true;

    let drillThroughType = this.$route.params.drillThroughName.split('-')[1].trim().split(' ')[0].trim();
    let drillThroughSeries = details.series;

    if (drillThroughType == 'DETAILS_MONTH') {
      this.tableTitle = `${drillThroughSeries} - Summary by GL Account`;
    } else {
      this.tableTitle = `${drillThroughSeries} - Details by Transaction`;
    }
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.profit-loss-drill-through-main {
  font-size: 12px;
  padding: 5px 45px;

  > .drill-through-body {
    background-color: white;
    height: 100%;
    width: 100%;
    border-radius: 5px;
    padding: 5px;
  }
}
</style>